import React, { useMemo } from 'react';
import { useLocalesQuery } from '../../../gql/hooks/queries/useLocalesQuery';
import SelectOrTransfer from '../../selectOrTransfer/SelectOrTransfer';

const LanguageSelectorCMX = ( { value, onChange, mode = 'select', showSearch = true, searchPlaceholder = 'Search...',
    excludelocales = [], hideExcludedLocales = true, ...otherProps } ) => {

    const { data, loading, error } = useLocalesQuery();

    const languageOptions = useMemo( () => {

        if ( loading === true || error || data === undefined ) {
            return [];
        } 

        const sourceData = data.locales.edges.map(  ( { node: { code, labelEnUs, cmxSupported } } ) => {
            return {
                key: code,
                label: labelEnUs,
                cmxSupported: cmxSupported
            };
        } );

        const mappedData = sourceData.filter(i => i.cmxSupported)
            .map(i => ({
                key: i.key,
                label: i.label,
                disabled: excludelocales.includes(i.key)
            }))
            .filter(i => !hideExcludedLocales || !i.disabled);

        const sortedData = mappedData.sort( ( optionA, optionB ) => {
            const labelOptionA = ( optionA?.label?.toLowerCase() || '' );
            const labelOptionB = ( optionB?.label?.toLowerCase() || '' );
            return labelOptionA.localeCompare( labelOptionB );
        } );

        return sortedData;
    }, [ loading, error, data, excludelocales ] );

    return (
        <SelectOrTransfer
            mode={ mode }
            dataSource={ languageOptions }
            value={ value }
            onChange={ onChange }
            showSearch={ showSearch }
            searchPlaceholder={ searchPlaceholder }
            { ...otherProps }
        />
    );
};

export default LanguageSelectorCMX;
